import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { NavigatorService } from '../navigator/navigator.service';
import { Router } from '@angular/router';
import { CommonService } from './../../page/common.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transition-page',
  templateUrl: './transition-page.component.html',
  styleUrls: ['./transition-page.component.scss', './transition-page.component.responsive.scss'],
  host: {
    class: 'center-route-content'
  }
})
export class TransitionPageComponent implements OnInit {
  transitionText: string;
  nextPage: string;

  constructor(
    private cs: CommonService,
    private router: Router,
    private ns: NavigatorService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      null,
      null,
      null,
      "transition-page",
      null,
      false,
      false,
      false,
      true,
      null,
      false,
      false,
      null,
      null,
      false,
      null,
      false
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(0);
    this.nextPage = this.getNextPage();
  }

  ngOnInit() {
    if (this.nextPage) {
      this.transitionText = "b2c.IDS_" + this.nextPage.toUpperCase() + "_TRANSITION";
      this.startInterval();
    } else {
      console.error("next page after transition not defined");
    }
  }

  startInterval() {
    setTimeout(() => {
      this.ns.navigateRoute("/wiz/" + this.nextPage, null);
    }, 2500);
  }

  getNextPage(): string {
    let currentNav = this.router.getCurrentNavigation();
    if (currentNav.extras && currentNav.extras.state && currentNav.extras.state.nextPage) {
      this.cs.setNextPageTransition(currentNav.extras.state.nextPage);
      return currentNav.extras.state.nextPage;
    } else if (this.cs.getNextPageTransition()) {
      return this.cs.getNextPageTransition();
    } else {
      return null;
    }
  }

}
